import {
  PWSProgram,
  PWSSamplingEvent
} from '@120wateraudit/envirio-components/dist/models'
import gql from 'graphql-tag'
import * as React from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { flowRight as compose } from 'lodash'
import { pwsClient } from 'src/apollo-clients'
import { DropdownItemProps } from 'semantic-ui-react'

const PROGRAMS_QUERY = gql`
  query programs($accountId: Int!, $programType: String) {
    programs(accountId: $accountId, programType: $programType) {
      id
      name
      programTypeId
    }
  }
`
const SAMPLING_EVENTS_QUERY = gql`
  query samplingEvents($accountId: Int!, $programType: String) {
    samplingEvents(accountId: $accountId, programType: $programType) {
      id
      name
      programId
    }
  }
`

interface RenderProps {
  programs: PWSProgram[] | null
  samplingEvents: PWSSamplingEvent[] | null
  programId?: number
  samplingEventId?: number
  onProgramSelected?: (_: any, data: DropdownItemProps) => void
  onSamplingEventSelected?: (_: any, data: DropdownItemProps) => void
}

interface Props {
  accountId: number
  programType?: string
  children: (args: RenderProps) => React.ReactNode
  programsData?: {
    loading?: boolean
    programs?: PWSProgram[]
  }
  samplingEventsData?: {
    loading?: boolean
    samplingEvents?: PWSSamplingEvent[]
  }
}

interface State {
  programId?: number
  samplingEventId?: number
}

class ProgramsAndSamplingEventsRPC extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  onProgramSelected = (_: any, data: DropdownItemProps) => {
    this.setState({ programId: data.value as number })
  }

  onSamplingEventSelected = (_: any, data: DropdownItemProps) => {
    this.setState({ samplingEventId: data.value as number })
  }

  render() {
    const { programsData, samplingEventsData } = this.props
    const { programId, samplingEventId } = this.state

    const programs =
      programsData && programsData.programs && !programsData.loading
        ? programsData.programs
        : null

    let samplingEvents =
      samplingEventsData &&
        samplingEventsData.samplingEvents &&
        !samplingEventsData.loading
        ? samplingEventsData.samplingEvents
        : null

    if (programId && samplingEvents) {
      samplingEvents = samplingEvents.filter(se => se.programId === programId)
    }

    return this.props.children({
      programs,
      samplingEvents,
      programId,
      samplingEventId,
      onProgramSelected: this.onProgramSelected,
      onSamplingEventSelected: this.onSamplingEventSelected
    })
  }
}

export default compose(
  graphql(PROGRAMS_QUERY, {
    name: 'programsData',
    options: ({ accountId, programType }: Props) => {
      return {
        client: pwsClient,
        variables: {
          accountId,
          programType
        }
      }
    }
  }),
  graphql(SAMPLING_EVENTS_QUERY, {
    name: 'samplingEventsData',
    options: ({ accountId, programType }: Props) => {
      return {
        client: pwsClient,
        variables: {
          accountId,
          programType
        }
      }
    }
  })
)(ProgramsAndSamplingEventsRPC)
